import { matchesDeleteConfirmationInput } from "../../invitations/coachDashboardClientActions";
import { resolveNutritionPlanName } from "./nutritionPlanNameUtils";

export const UNNAMED_NUTRITION_PLAN_DELETE_CONFIRMATION = "DELETE";

export function getNutritionPlanDeleteExpectedValue(...sources) {
  return (
    resolveNutritionPlanName(...sources) || UNNAMED_NUTRITION_PLAN_DELETE_CONFIRMATION
  );
}

export function matchesNutritionPlanDeleteConfirmation({
  input,
  planLike,
  expectedValue,
} = {}) {
  return matchesDeleteConfirmationInput({
    input,
    expectedValue:
      expectedValue ??
      getNutritionPlanDeleteExpectedValue(planLike),
  });
}
